import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import styles from "./styles/News.module.css";
import a1 from "./images/articles/a1.jpg";
import a2 from "./images/articles/a2.jpg";
import a3 from "./images/articles/a3.jpg";
const Articles = () => {
  const articles = [
    {
      id: 1,
      title: "نحوه استفاده صحیح و نگهداری اصولی از باتری خودرو",
      excerpt:
        "راهنمای جامع برای افزایش طول عمر باتری خودرو با روش‌های ساده اما مؤثر",
      image: a1,
    },
    {
      id: 2,
      title: "10 نشانه باتری معیوب خودرو که باید بشناسید",
      excerpt: "چگونه مشکلات باتری خودرو را قبل از خرابی کامل تشخیص دهیم؟",
      image: a2,
    },
    {
      id: 3,
      title: "معرفی باتری‌های پرفروش صبا باتری برای خودروهای مختلف",
      excerpt: "بررسی تخصصی بهترین مدل‌های باتری صبا برای خودروهای پرکاربرد",
      image: a3,
    },
  ];

  return (
    <>
      <Navbar />

      <div className={styles.newsContainer}>
        <h1 className={styles.pageTitle}>مقالات تخصصی باتری خودرو</h1>
        <p className={styles.pageSubtitle}>
          آخرین اطلاعات و راهنمایی‌های فنی درباره باتری خودرو
        </p>

        <div className={styles.articlesGrid}>
          {articles.map((article) => (
            <div key={article.id} className={styles.articleCard}>
              <img
                src={article.image}
                alt={article.title}
                className={styles.articleImage}
              />
              <div className={styles.articleContent}>
                <h2 className={styles.articleTitle}>
                  <Link
                    to={`/مقالات/${article.id}`}
                    className={styles.articleLink}
                  >
                    {article.title}
                  </Link>
                </h2>
                <p className={styles.articleExcerpt}>{article.excerpt}</p>
                <Link
                  to={`/مقالات/${article.id}`}
                  className={styles.readMoreButton}
                >
                  مطالعه مقاله
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.aboutSection}>
          <h2>
            درباره{" "}
            <a href="https://battery100.ir" className={styles.siteLink}>
              باتری۱۰۰
            </a>
          </h2>
          <p>
            وبسایت{" "}
            <a href="https://battery100.ir" className={styles.siteLink}>
              battery100.ir
            </a>{" "}
            مرجع تخصصی اطلاعات باتری ups و باتری خودرو و ارائه‌دهنده بهترین
            محصولات با گارانتی معتبر است. ما در <strong>باتری۱۰۰</strong> تلاش
            می‌کنیم با ارائه مقالات کاربردی و دقیق، به افزایش آگاهی مشتریان کمک
            کنیم.
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Articles;
